import { useUnit } from 'effector-react';
import _ from 'lodash';
import $$api from 'models/api';
import navigate from 'models/router-gate';
import { $global, storage } from 'models/store-global';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isna, queryParser } from 'utils/common-helper';

import useEventListener from 'hooks/useEventListener';

import { MyStore } from 'types/Store';

export const useProfileLinker = async () => {
    const { search } = useLocation();
    const invite = queryParser(search)?.invite ?? localStorage.getItem(`invite`);
    const isAuthenticated = useUnit($global.map((state) => state.auth?.isAuthenticated === true));
    useEffect(() => {
        (async () => {
            if (!isna(invite)) {
                storage.set((store): MyStore => ({ ...store, toBeLinked: true }));
                if (isAuthenticated) {
                    localStorage.removeItem(`invite`);
                    await $$api.participants.linkRegisteredUserFx(invite);
                    const newCommunity = await $$api.participants.getCommunityFx(undefined);
                    const participantId = _.map(newCommunity.assigned, `participant_id`)?.[0];
                    if (participantId) {
                        navigate(`/community/assigned/${participantId}`);
                    }
                } else {
                    try {
                        localStorage.setItem(`invite`, invite);
                    } catch (error) {}
                }
            }
        })();
    }, [JSON.stringify({ search, invite, isAuthenticated })]);

    useEventListener(`beforeunload`, () => {
        localStorage.removeItem(`invite`);
    });
};

export const useLinkingVerification = () => {
    useEffect(() => {
        const code = localStorage.getItem('needToVerifyLink');
        if (code) {
            $$api.participants.verifyLinkingFx(code);
            localStorage.removeItem('needToVerifyLink');
        }
    }, []);
};

const ProfileLinker = () => {
    useProfileLinker();
    return null;
};

export default ProfileLinker;
